<template>
    <div class="form">

        <!-- Avoid options -->
        <div class="form__section">
            <div class="form__title">Bevorzugte Verkehrsmittel (maximal 4)</div>
            <div class="form__description copy-light">Die Routen für maximal vier ausgewählte Verkehrsmittel werden direkt berechnet und in der hier gewählten Reihenfolge im Vergleich angezeigt.</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.type" 
                        :options="typeOptions"
                        :output-array="true"
                        :min-amount="1"
                        :max-amount="4"
                        :keep-view-sorting="true"
                        :tracking-data-label="'General'"
                        :tracking-data-category="'Route Planner'"
                        :tracking-data-ga4-event="'route_planner_settings'"
                        :sortable="true"
                        @change="fieldChangeHandler($event, 'type')"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import transportModes from '@/data/transportModes';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import { sortObjectByArray } from '@/utils/sorting';
export default {
    components: {
        SmrChoiceGroup,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            typeOptions: [...transportModes]
        }
    },
    mounted() {
        this.sortTypeOptions();
    },
    methods: {
        sortTypeOptions() {
            return sortObjectByArray(this.typeOptions, 'value', this.data.type);
        },
    }

}
</script>
